<template>
  <div id="firefighter" style="text-align:center;">
    <img class="fire_pc_main" src="../assets/img/firefighter/firefighter_main2.jpg" style="width:100%;" alt="">
    <img class="fire_mo_main" src="../assets/img/firefighter/fire_main_mo.jpg" style="width:100%;" alt="">
    <!-- <img class="fire_one" src="../assets/img/firefighter/fire_one.png" alt=""> -->
    
    <div class="fire_pink_bg">
      <div class="fire_pink_bg_under">
        <img class="fire_two" src="../assets/img/firefighter/fire_two2.jpg" alt="">
        <img class="fire_fighter" src="../assets/img/firefighter/fighter.png">
      </div>
     </div>
     <div class="fire_title_text">
        <h1 class="fire_title_main">
          엔데이트립이 운영하는 버스투어<br>
          모든 코스를 이용하실 수 있습니다.
        </h1>
        <p class="fire_title_sub">
          각 코스의 일정과 상세 내용은 아래 썸네일을 통해 확인 가능하며<br class="pc_br">
          투어 참여는 참여하기를 통해 신청해 주세요.
        </p>
        <p class="fire_title_notice">
          무료 지원 프로그램이라 하더라도 제공되는 서비스에는 일절 차이가 없는<br class="pc_br">
          기존 상품과 동일한 서비스가 제공되오니 소방 관련 공무원께서는 많은 이용 바랍니다
        </p>
      </div>
     <div id="fire_under_bt" class="fire_bt2">
        <a href="https://naver.me/xGINNypJ" >참여하기</a>

     </div>
     


     <div class="fire_line"></div>

    <div class="fire_prodt_bg" >
      <div class="fire_hokkaido" >
        <div class="fire_title_left">
          <h3 class="fire_area_name">북해도</h3>
          <p class="fire_area_desc">
            겨울 비에이의 낭만적인 설경과 귀여운 펭귄과의 만남, 따뜻한 노보리베츠 온천<br class="pc_br">
            여름 후라노의 광활한 라벤더 밭과 가슴 탁 트이는 샤코탄의 해안까지 매력으로 가득찬 곳
          </p>
        </div>
        

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/hk_biei.png" @click="goToDetail('L-202346-1680743217094', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/hk_asahiyama.png" @click="goToDetail('L-20231220-1703058504372', 'L')" alt="">
          <img src="../assets/img/firefighter/hk_nobo.png" @click="goToDetail('L-2431993LGC', 'L')" alt="">
        </div>

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/hk_oshiho.png" @click="goToDetail('L-20231026-1698301178789', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/hk_hhk.png" @click="goToDetail('L-20231019-1697704655687', 'L')" alt="">
        </div>
      </div>
    </div>
    
    <div class="fire_line"></div>

    <div class="fire_prodt_bg" >
      <div class="fire_hokkaido" >
        <div class="fire_title_left">
          <h3 class="fire_area_name">오사카</h3>
          <p class="fire_area_desc">
            일본 전통이 살아 숨 쉬는 교토의 고즈넉한 거리와 신사·사찰, 교토 북부 작은 어촌 마을 <br class="pc_br">
            이네후나야에서 만나는 이국적이고 그림 같은 절경까지! 교토의 다채로운 매력을 한 번에 만나보세요.
          </p>
        </div>
      
        <div class="fire_pr_img" >
          <img src="../assets/img/firefighter/hs_kyoto.png" @click="goToDetail('L-2023220-1676865317720', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/inehunaya.png" @click="goToDetail('L-202574-1751620690729', 'L')"  alt="">
        </div>
      </div>
    </div>

    <div class="fire_line"></div>

    <div class="fire_prodt_bg">
      <div class="fire_hokkaido">
        <div class="fire_title_left">
          <h3 class="fire_area_name">나고야</h3>
          <p class="fire_area_desc">
            유잼 도시 나고야의 다채로운 매력!! 깊은 산속 동화 같은 설경을 품은 시라카와고와 다카야마<br class="pc_br">
            서울보다 넓은 비와호 주변의 아름다운 명소까지, 중부 일본의 매력을 엔데이트립과 함께 정복해 보세요!
          </p>
        </div>
        <div class="fire_pr_img" style="margin-bottom: 80px;">
          <img src="../assets/img/firefighter/hs_nagoya.png" @click="goToDetail('L-2023221-1676943535719', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/biwako.png" @click="goToDetail('L-2652846GQC', 'L')"  alt="">
        </div>
      </div>
    </div>

    <div class="fire_line"></div>
    <div class="fire_prodt_bg">
      <div class="fire_hokkaido">
        <div style="text-align:left;">
          <h3 class="fire_area_name">도쿄</h3>
          <p class="fire_area_desc">
            대도심 도쿄에서 떠나는 특별한 근교 여행, 인생샷으로 유명한 후지산 주변 포토스팟부터<br class="pc_br">
            유명 온천지역 하코네, 이 사랑 통역되나요, 환승연애 등의 촬영지 가마쿠라로 떠나세요!
          </p>
        </div>

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/hs_tokyo.png" @click="goToDetail('L-2023329-1680070456245', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/enoshima.png" @click="goToDetail('L-262968PLC', 'L')" alt="">
          <img src="../assets/img/firefighter/fuji.png" @click="goToDetail('L-264859BPC', 'L')" alt="">
        </div>        
        <!-- <div class="fire_pr_img" style="text-align:left;">
          <img src="../assets/img/firefighter/shikoku_mas.png" @click="goToDetail('L-24112101RNC', 'L')" alt="">
        </div> -->
      </div>
    </div>

    <div class="fire_line"></div>
    <div class="fire_prodt_bg">
      <div class="fire_hokkaido">
        <div style="text-align:left;">
          <h3 class="fire_area_name">기타큐슈 후쿠오카</h3>
          <p class="fire_area_desc">
            유후인 벳푸 등 유명 온천 마을부터 푸른 바다와 하늘이 맞닿는 이토시마, 츠노시마대교, 모토노스미까지!<br class="pc_br">
            따뜻한 온천의 여유와 눈부신 해안 풍경이 어우러진 기타큐슈·후쿠오카 근교 여행을 즐겨보세요!
          </p>
        </div>

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/ks_yama.png" @click="goToDetail('L-2024312-1710224515956', 'L')" alt="">
          <img class="pr_img_midle" src="../assets/img/firefighter/ks_yufu.png" @click="goToDetail('L-2025324-1742803712116', 'L')" alt="">
          <img src="../assets/img/firefighter/karatsu.png" @click="goToDetail('L-2633156JRC', 'L')" alt="">
        </div>        
        <!-- <div class="fire_pr_img" style="text-align:left;">
          <img src="../assets/img/firefighter/shikoku_mas.png" @click="goToDetail('L-24112101RNC', 'L')" alt="">
        </div> -->
      </div>
    </div>
    <div id="fire_under_bt" class="fire_bt">
      <a href="https://naver.me/xGINNypJ" >참여하기</a>
    </div>
  </div>
</template>

<script>

import defaultPath from '@/assets/img/taiwan/back.jpg';

export default {
  // DB에서 가져온 데이타
  data() {
    return {
      //imagePath: "/IMGs/testtaiwan/back.jpg"   //상단이미지 default
      imagePath: defaultPath,   //상단이미지 default
      animateImage: false
    };
  },
  created() {
    this.bSeq = this.$route.query.bSeq;
    this.chkSize = window.innerWidth
    //alert(this.chkSize) 화면 사이즈 체크
  },
  // filters: {
  //   currency: function(val) {
  //     var num = new Number(val);
  //     return num.toFixed(0).replacereplace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  // },
  computed: {
    user() {
      return this.$store.state.user;
    }   
  },
  methods: {
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    }
  },
  mounted() {

    // //권한없는 로그인 차단
    // if(this.user.handlerGrade >= 20) {
    //   var swal = require('sweetalert2');
    //   swal.fire({
    //     title: '로그인 필요', 
    //     text: '접근권한 확인불가.',
    //     icon: 'error'
    //   });
    //   this.$router.push({path: '/'}); 
    // }

}}


</script>

<style scoped>
@keyframes moveUpDown {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px); /* 위로 5px 이동 */
    }
    100% {
        transform: translateY(0);
    }
}
#firefighter{
  margin-top: -56px;
}
.fire_mo_main{
  display: none;
}
.fire_pr_img>img{
  transition: all 0.2s;
  box-shadow: 3px 3px 10px;
  width: 350px;
}

.fire_pr_img>img:hover{
  transition: all 0.2s;
  transform: translateY(-10px);
}
.firstimg{
  position: relative;
  top: 0;
  left: 0;
  z-index: 8;
}

.fire_one{
  position: relative;
  top: -100px;
    width: 40%;
}
.fire_pink_bg{
  background-color: #ff7800;
  width:100%;
  margin-top:-340px;
  text-align:center;
  padding:400px 00px 150px 0px
}
.fire_pink_bg_under{
  width:1500px;
  height:900px;
  background:#fff;
  display:inline-block;
}
.fire_two{
  margin-top: 100px; width:60%;
}
.fire_title1{
  margin:130px 0 30px;
  width:30%;
}
.fire_under{
  width: 5%;
  margin:0 auto;
  padding-bottom: 50px;
  display: block;
  animation: moveUpDown 2s infinite alternate;
}
.fire_line{
  width: 100%;
  height:50px;
  background-color: #ff7800;
}
.fire_prodt_bg{
  background-color: #fff;
  width:100%; 
  padding:150px 0 150px 0px;
  margin:0 auto;
}
.fire_hokkaido{
  width: 1200px; margin:0 auto; text-align: center;
}
.fire_title_left{
  text-align: left;
}
.title_left{
  text-align:left;
  margin-bottom:50px;
  width:80%;
}
.fire_pr_img{
  margin-bottom: 80px;
}
.pr_img_midle{
  margin:0 75px;
}
.fire_bt{
  margin:100px auto;
  text-align:center;
  width:1200px;
}
.fire_bt2{
  margin:50px auto 100px auto;
  text-align:center;
  width:1200px;
}
.fire_bt a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:18pt;
  font-weight:large;
  transition: all 0.5s;
}
.fire_bt a:hover{
  color:#fff;
  background-color:#914300;
  transition: all 0.5s;
}
.fire_bt2 a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:18pt;
  font-weight:large;
  transition: all 0.5s;
}
.fire_bt2 a:hover{
  color:#fff;
  background-color:#914300;
  transition: all 0.5s;
}
.nika_left{
  text-align: left;
}
.fire_fighter{
  position:absolute;
  right:0;
  bottom:-1576px;
  z-index:3;
  width:20%;
}

.fire_title_text{
  margin:130px 0 30px;
  text-align:center;
}
.fire_title_main{
  margin:0 0 22px;
  color:#ff7800;
  font-size:32px;
  font-weight:800;
  line-height:1.05;
  letter-spacing:-0.5px;
}
.fire_title_sub{
  margin:0 0 30px;
  color:#ff7800;
  font-size:19px;
  line-height:1.4;
}
.fire_title_notice{
  margin:0;
  color:#ff7800;
  font-size:19px;
  line-height:1.5;
}

.fire_area_name{
  margin:0 0 10px;
  color:#000;
  font-size:56px;
  font-weight:800;
  line-height:1.2;
  letter-spacing:-1px;
  text-align:left;
}
.fire_area_desc{
  margin:0 0 50px;
  color:#000;
  font-size:22px;
  line-height:1.45;
  text-align:left;
}


@media(max-width:1920px){
.fire_fighter{
  position:absolute;
  right:0;
  bottom:-1523px;
  z-index:3;
  width:20%;
}
}
@media(max-width:768px){
  .fire_one{
    top: -35px;
    width: 80%;
  }

  .fire_pink_bg{
    background-color: #ff7800;
    margin-top:-100px;
    padding:100px 00px 50px 0px
  }
  .fire_pink_bg_under{
    width:95%;
    height:calc(350px);
  }
  .fire_two{
    margin-top: 50px;
    width:90%;
  }
  .fire_fighter{
    display:none;
  }
  .fire_title1{
    margin:40px 0 20px;
    width:90%;
  }
  .fire_line{
    height:10px;
  }


  .fire_prodt_bg{
    background-color: #fff;
    width:100%; 
    padding:50px 0 50px 0px;
    margin:0 auto;
  }
  .fire_hokkaido{
    width: 95%;
    margin-left: 8%;
  }
  .fire_title_left{
    text-align: left;
  }
  .title_left{
    text-align:left;
    margin: 0%  0% 20px 0;
    width:90%;
  }
  .fire_pr_img{
    margin-bottom: 10px;
    width: 90%;
  }
  .pr_img_midle{
    margin:20px 0;
  }
  .fire_pr_img>img{
    width: 100%;
  }
  .fire_bt{
    text-align:center;
    width:100%;
    margin: 40px auto;
  }
  .fire_bt a{
    display:block;
    margin:0 auto;
    width: 300px;
    height:80px;
    border-radius:10px;
    padding-top:1.4rem;
    color:#fff;
    background-color:#ff7800;
    font-size:15pt;
    font-weight:600;
  }
  .fire_bt2{
    text-align:center;
    width:100%;
    margin: 40px auto;
  }
  .fire_bt2 a{
    display:block;
    margin:0 auto;
    width: 300px;
    height:80px;
    border-radius:10px;
    padding-top:1.4rem;
    color:#fff;
    background-color:#ff7800;
    font-size:15pt;
    font-weight:600;
  }
  #firefighter{
    margin-top: 35px;
  }
  .fire_pc_main{
    display: none;
  }
  .fire_mo_main{
    display: block;
  }
  .fire_title_text{
    margin:40px 0 20px;
    padding:0 5%;
  }
  .fire_title_main{
    margin-bottom:14px;
    font-size:20px;
  }
  .fire_title_sub{
    margin-bottom:20px;
    font-size:13px;
  }
  .fire_title_notice{
    font-size:12px;
  }
  .pc_br{
    display:none;
  }

  .fire_area_name{
    margin-bottom:8px;
    font-size:30px;
  }
  .fire_area_desc{
    margin-bottom:20px;
    width:90%;
    font-size:13px;
    line-height:1.5;
  }
}
</style>

